module.exports = __webpack_public_path__ + "static/media/Lunatone_gaussian2.64e6b74a.png";